import React, { useEffect, useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { resolveStatusColumn } from "@helpers/helpers";
import {
  TIMEOUT_VALUE,
  TOP_OFFSET_VALUE,
  LEFT_OFFSET_VALUE,
  DEFAULT_LEGEND_STATUSES,
} from "./constants";
import { useTheme } from "@stores/ThemeContext";
import { Info } from "lucide-react";

function LegendComponent({ data, inline = false, dataToHide = [] }) {
  const { t: translate, i18n } = useTranslation();
  const [opened, setOpened] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();

  const defaultData = DEFAULT_LEGEND_STATUSES.map((status) => ({
    ...status,
    text: translate(status.textKey),
  }));

  const updatedDefaultData = defaultData.filter(
    (item) => !dataToHide.includes(item.tag)
  );

  const dataToShow = [...updatedDefaultData, ...data];

  useEffect(() => {
    let TOP_OFFSET = 30;
    let LEFT_OFFSET = 0;
    if (opened) {
      setTimeout(() => {
        const parent = document.getElementById(`parent_legend`);
        const child = document.getElementById(`child`);

        if (child) {
          const parentRect = parent.getBoundingClientRect();

          const top = parentRect.top;
          const left = parentRect.left;

          if (i18n.language === "ar") {
            LEFT_OFFSET = LEFT_OFFSET_VALUE * child.offsetWidth;
            TOP_OFFSET = TOP_OFFSET_VALUE;
          }

          child.style.top = `${top + TOP_OFFSET}px`;
          child.style.left = `${left + LEFT_OFFSET}px`;
        }
      }, TIMEOUT_VALUE);
    }
  }, [opened]);

  const handleClick = () => {
    setOpened(!opened);
  };

  const renderContent = () => {
    return dataToShow.map((item, index) => (
      <div
        key={index}
        className={clsx(
          !inline && "rtl:flex-row-reverse",
          `flex w-max gap-3 items-center`
        )}
      >
        {resolveStatusColumn(
          "",
          item.tag,
          ["INPROGRESS"],
          null,
          "",
          translate,
          isDarkMode
        )}
        <span className="text-sm">{item.text}</span>
      </div>
    ));
  };

  if (inline) {
    return <div className="flex gap-3 items-center">{renderContent()}</div>;
  }

  return (
    <div>
      <Info
        id="parent_legend"
        className="hover:scale-110 hover:text-primary-800 transition-all duration-200 cursor-pointer"
        onMouseEnter={() => setOpened(true)}
        onMouseLeave={() => setOpened(false)}
        size={18}
      />
      {opened && (
        <div
          id="child"
          className="flex dark:bg-gray-800 flex-col ltr:left-[3px] rtl:items-end gap-3 p-4 fixed bg-white shadow-xl rounded-md text-xs z-[1]"
        >
          {renderContent()}
        </div>
      )}
    </div>
  );
}

export default LegendComponent;
